import i18n from "../../../i18n";

export const instanceGroupFields = [
    {
        key: "name",
        label: i18n.t("instanceGroups.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
